import type { EndpointMeta } from "@/apis/types";
import {
  createFetchAndHook,
  type FetchFactory,
  type HookFactory,
} from "@/shared/factories";
import { wsfScheduleApiMeta } from "../apiMeta";
import {
  type TimeAdjustmentsByRouteInput,
  timeAdjustmentsByRouteInputSchema,
} from "./shared/timeAdjustments.input";
import {
  type TimeAdjustment,
  timeAdjustmentSchema,
} from "./shared/timeAdjustments.output";

/**
 * Metadata for the fetchTimeAdjustmentsByRoute endpoint
 */
export const timeAdjustmentsByRouteMeta = {
  functionName: "fetchTimeAdjustmentsByRoute",
  endpoint: "/timeadjbyroute/{RouteID}",
  inputSchema: timeAdjustmentsByRouteInputSchema,
  outputSchema: timeAdjustmentSchema.array(),
  sampleParams: { RouteID: 1 },
  endpointDescription: "List time adjustments for a specific route.",
} satisfies EndpointMeta<TimeAdjustmentsByRouteInput, TimeAdjustment[]>;

const { fetch, useHook } = createFetchAndHook<
  TimeAdjustmentsByRouteInput,
  TimeAdjustment[]
>({
  api: wsfScheduleApiMeta,
  endpoint: timeAdjustmentsByRouteMeta,
  getCacheStrategy: () =>
    // eslint-disable-next-line @typescript-eslint/no-var-requires
    require("./shared/timeAdjustments.endpoints").timeAdjustmentsGroup
      .cacheStrategy,
});

/**
 * Fetch function for retrieving time adjustments for a specific route
 */
export const fetchTimeAdjustmentsByRoute: FetchFactory<
  TimeAdjustmentsByRouteInput,
  TimeAdjustment[]
> = fetch;

/**
 * React Query hook for retrieving time adjustments for a specific route
 */
export const useTimeAdjustmentsByRoute: HookFactory<
  TimeAdjustmentsByRouteInput,
  TimeAdjustment[]
> = useHook;
